import makeUniqueId from 'helpers/makeUniqueId'

const topInformationTypes = {
	SUCCESS: 'success',
	ERROR: 'error',
}

const defaultMessage = {
	timeout: 3000,
	styleType: '',
	uid: makeUniqueId(),
}

const topInformationGenerator = options => ({
	...defaultMessage,
	...options,
})

function closeTopInformation(topInformationState, uid) {
	const index = topInformationState.findIndex(information => information.uid === uid)
	if (index !== -1) {
		return [
			...topInformationState.slice(0, index),
			...topInformationState.slice(index + 1),
		]
	} else {
		return topInformationState
	}
}

export {
	topInformationTypes,
	topInformationGenerator,
	closeTopInformation,
}
